import { UrlPartInfo } from './url-part-info';

export class PublicationStatusInfo {
    public organizationId: number = 0;
    public consumerId: number = 0;
    public isCanonical: boolean = false;
    public urlParts: UrlPartInfo[] = [];
    public isPublished: boolean = false;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            urlParts: json.urlParts ? json.urlParts.map((urlPart: any) => new UrlPartInfo(urlPart)) : [],
        });
    }

    public clone(): PublicationStatusInfo {
        const status: PublicationStatusInfo = new PublicationStatusInfo();

        status.organizationId = this.organizationId;
        status.consumerId = this.consumerId;
        status.isCanonical = this.isCanonical;
        status.urlParts = this.urlParts.map((urlPart) => urlPart.clone());
        status.isPublished = this.isPublished;

        return status;
    }
}

export class PublicationStatusInfoExtended extends PublicationStatusInfo {
    public consumerName: string = '';

    constructor(json?: any) {
        super(json);

        if (!json) {
            return;
        }

        if (json.consumerName) {
            this.consumerName = json.consumerName.toString();
        }
    }
}
